'use client';

import { StyledTooltipContainer } from '@components/InternalIcons/Tooltip.styled';
import { openInternalPopup } from '@components/InternalIcons/utils/internalPopup';
import { Box, Tag } from '@coolblue-development/freddy';
import selectOptionTrigger from '@coolblue-development/ga4-events/triggers/InternalIcons/selectOptionTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ReactElement } from 'react';

type StockInOtherLocationsIconProps = {
  stockCount?: number;
  url: string;
  index: number;
  totalIndices: number;
};

const StockInOtherLocationsIcon = ({
  stockCount,
  url,
  index,
  totalIndices
}: StockInOtherLocationsIconProps): ReactElement => {
  const { trackEvent } = useAnalytics();

  if (stockCount === null || stockCount === undefined) {
    return (
      <Box>
        <Tag variant='subtle' intent='neutral'>
          - in other locations
        </Tag>
      </Box>
    );
  }

  const getMessage =
    stockCount === 0 ? 'None in other locations' : `${stockCount} in other locations`;

  return (
    <StyledTooltipContainer
      data-internal-icons-tooltip='Open Iris product dashboard'
      data-testid='other-locations-stock-icon'
    >
      <Tag
        onClick={() => {
          trackEvent(
            selectOptionTrigger({
              sub_feature: 'stock_information',
              index: index,
              total_indices: totalIndices,
              selection_type: 'selected',
              option_name: 'other_locations_stock',
              attribute: 'other_locations_stock'
            })
          );
          openInternalPopup(url);
        }}
        variant='subtle'
        intent='neutral'
      >
        {getMessage}
      </Tag>
    </StyledTooltipContainer>
  );
};

export default StockInOtherLocationsIcon;
